const datatableTypes = Object.freeze({
  ICON: "iconTag",
  LINK: "linkText",
  TEXT: "plainText",
});

export default datatableTypes;
